import React, {useEffect} from 'react'

import {motion, useAnimation} from 'framer-motion'

export const Other = () => {
  const controls = useAnimation()
  const OTHER = [
    {
      title: 'Data Analytics',
      key: 'data',
      link: 'https://www.datawow.co.th/services/data-analytics',
    },
    {
      title: 'Data Labeling',
      key: 'category',
      link: '/services/data-labeling',
    },
    {
      title: 'PDPA Service',
      key: 'pdpa',
      link: 'https://www.datawow.co.th/products/pdpa-core',
    },
    {
      title: 'Training Service',
      key: 'training',
      link: 'https://wowlearn.datawow.co.th/',
    },
  ]

  useEffect(() => {
    const element = document.querySelector('.CustomAI__other')
    const onScroll = () => {
      const elementTop = element.getBoundingClientRect().top
      const windowHeight = window.innerHeight

      if (elementTop < windowHeight * 0.75) {
        controls.start({opacity: 1, y: 0})
      } else {
        controls.start({opacity: 0, y: 50})
      }
    }

    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [controls])

  return (
    <motion.div
      className='CustomAI__other'
      initial={{opacity: 0, y: 10}}
      animate={controls}
      transition={{duration: 0.1}}
    >
      <h2>
        Other <span>Services</span>
      </h2>
      <div className='CustomAI__other__content'>
        {OTHER.map((item) => (
          <a
            className='CustomAI__other__content__item'
            key={item.key}
            href={item.link}
            target={item.link.includes('https:') ? '_blank' : '_self'}
            rel='noreferrer'
          >
            <img
              src={`/images/custom-ai/other-${item.key}.svg`}
              alt={item.key}
              width='100px'
              loading='lazy'
            />
            <h3>{item.title}</h3>
          </a>
        ))}
      </div>
      <div className='CustomAI__other__bg__desktop'>
        <img
          className='CustomAI__other__bg__image'
          alt='custom-ai-other-bg'
          src='/images/custom-ai/other-bg-desktop.png'
        ></img>
      </div>
      <div className='CustomAI__other__bg__mobile'>
        <img
          className='CustomAI__other__bg__image'
          alt='custom-ai-other-bg'
          src='/images/custom-ai/other-bg-mobile.png'
        ></img>
      </div>
    </motion.div>
  )
}
